export const defaultLoadingPaneGeneralStyles = {
  width: "100%",
  height: "100%",
  borderWidth: "3px",
  borderStyle: "solid",
  backgroundColor: "#315fa2",
  borderColor: "#F1F1F1",
  position: "absolute",
  justifyContent: "center",
  alignItems: "center"
};